import { createReducer, makeActionCreator } from "util/redux";

export const types = {
    MENU_SHOW: "menu/MENU_SHOW",
    MENU_CLOSE: "menu/MENU_CLOSE",
};

export const INITIAL_STATE = {
    displayMenu: false,
};

export default createReducer(INITIAL_STATE, {
    [types.MENU_SHOW]: (state) => ({ ...state, displayMenu: true }),
    [types.MENU_CLOSE]: (state) => ({ ...state, displayMenu: false }),
});

export const actions = {
    menuShow: makeActionCreator(types.MENU_SHOW),
    menuClose: makeActionCreator(types.MENU_CLOSE),
};
